import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

export interface Profile {
  id: string;
  username: string | null;
  username_slug: string | null;
  is_featured: boolean;
  profession: string | null;
}

export function useSearchSuggestions(searchValue: string) {
  const [suggestions, setSuggestions] = useState<Profile[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  // Fetch suggestions when search value changes
  useEffect(() => {
    const fetchSuggestions = async () => {
      if (searchValue.trim().length < 2) {
        setSuggestions([]);
        return;
      }

      setIsLoading(true);
      try {
        const { data, error } = await supabase
          .from('profiles')
          .select('id, username, username_slug, is_featured, profession')
          .or(`username.ilike.%${searchValue}%,profession.ilike.%${searchValue}%`)
          .limit(5);

        if (error) {
          console.error('Error fetching suggestions:', error);
          return;
        }

        setSuggestions(data || []);
      } catch (error) {
        console.error('Unexpected error:', error);
      } finally {
        setIsLoading(false);
      }
    };

    const debounceTimeout = setTimeout(() => {
      if (searchValue.trim()) {
        fetchSuggestions();
      }
    }, 300);

    return () => clearTimeout(debounceTimeout);
  }, [searchValue]);

  return {
    suggestions,
    isLoading
  };
} 